module.exports = __webpack_public_path__ + "img/user active.bd7deba9.svg";